import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Icons from "../../../Config/Images";
import { useDispatch } from "react-redux";
import { getProductMetalDetailsAPI } from "../../../Store/Action/productMetalAction";
import Header from "../Layout/Header/Header";
import Footer from "../Layout/Footer/Footer";
import { BASE_URL } from "../../../Constants/AppConstants";
const AllShopByColors = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [allMetals, setAllMetals] = useState([]);

  useEffect(() => {
    dispatch(
      getProductMetalDetailsAPI({}, (isSuccess, result) => {
        if (result?.status) {
          setAllMetals(result?.data);
        }
      })
    );
  }, [dispatch]);
  const handleIndividualMetal = (metalId, metalName) => {
    // Navigate to another route with subcategories (passing fetched data directly)
    // navigate("/sub-categories", {
    //   state: { metalId: metalId },
    // });
    navigate(`/shop-by-color/${metalName}`, {
      state: { metalId: metalId, metalName: metalName, fromProductMetal: true },
    });
  };

  return (
    <>
      {/* Header */}
      <Header />

      <div className="shopByColorDiv">
        <div className="headingContent">
          <h1>Shop by Color</h1>
        </div>

        <div className="lowerContent">
          <div className="hrLine"></div>
          {/* <div className="view-all">
        <p onClick={handleViewAllClickFunc}>View all</p>
        </div> */}
          <div className="cardsMainDiv">
            {allMetals?.map((color, index) => (
              <Card
                key={index}
                className="card"
                sx={{
                  height: 525,
                  position: "relative",
                  boxShadow: "none",
                  cursor: "pointer",
                }}
              >
                <div
                  onClick={() =>
                    handleIndividualMetal(
                      color.product_metal_id,
                      color.product_metal_name
                    )
                  }
                >
                  <CardMedia
                    component="img"
                    height="414"
                    image={`${BASE_URL}/${color?.product_metal_image?.[0]?.product_metal_image_url}`}
                    alt={color.name}
                  />
                  <CardContent>
                    <div className="arrowCircleDiv">
                      <img
                        className="arrowCircleImg"
                        src={Icons.arrowCircleRightImage}
                        alt="arrow icon"
                      />
                    </div>
                    <div className="colorLabel">
                      <p>{color.product_metal_name}</p>
                    </div>
                  </CardContent>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>

      {/* Footer  */}
      <Footer />
    </>
  );
};

export default AllShopByColors;
